import React, { Component, Fragment } from 'react';
import { string, number, oneOf, func, bool } from 'prop-types';
import CompactUserInfo from '../CompactUserInfo';
import { Popover, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@material-ui/core';
import { Edit, Delete, RemoveRedEye, VpnKey, AssignmentInd, ArrowDropDown } from '@material-ui/icons';
import { OWNER, MANAGER, EDITOR, VIEWER, INHERIT } from '../../helpers/constant';

import styles from './styles.scss';

export default class UserPrivilegeInfo extends Component {
  static propTypes = {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    profileImage: string,
    isCurrentUser: bool,
    disableSetOwner: bool,
    permission: oneOf([OWNER, MANAGER, EDITOR, VIEWER, INHERIT]),
    ownerLabel: string,
    managerLabel: string,
    setEditLabel: string,
    setViewLabel: string,
    setOwnerLabel: string,
    inheritLabel: string,
    toolTipText: string,
    onDelete: func,
    onChange: func
  }

  static defaultProps = {
    ownerLabel: 'Owner',
    managerLabel: 'Manager Access',
    setEditLabel: 'Can edit',
    setViewLabel: 'Can view',
    setOwnerLabel: 'Make owner',
    inheritLabel: 'Has access to Advertiser',
    toolTipText: 'Change Access'
  }

  state = {
    anchorEl: null
  }
  
  handleChange = (newRole) => () => {
    const { onChange, permission, id } = this.props;
    if (newRole && newRole !== permission) {
      onChange && onChange({id, permission: newRole});
    }
    this.handleClose();
  }

  handleDelete = () => {
    const { onDelete, id } = this.props;
    onDelete && onDelete(id);
  }
  
  handleEditClick = (role) => (e) => {
    const isManager = role === MANAGER;
    this.setState({
      anchorEl: e.currentTarget,
      isManager
    });
  }

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  }

  drawPopover() {
    const { setEditLabel, setViewLabel, setOwnerLabel, disableSetOwner } = this.props;
    const { anchorEl, isManager } = this.state;

    return (
      <Popover
        className={styles.userPrivilegePopover}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={this.handleClose}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
      >
      { !isManager &&
        <Fragment>
          <MenuItem data-test="privilegeEditorOption" onClick={this.handleChange(EDITOR)}>
            <ListItemIcon className={styles.listIcon}>
              <Edit/>
            </ListItemIcon>
            <ListItemText className={styles.listText}>
              {setEditLabel}
            </ListItemText>
          </MenuItem>
          <MenuItem 
            data-test="privilegeViewerOption"
            onClick={this.handleChange(VIEWER)} 
            className={styles.menuDivider}
          >
            <ListItemIcon className={styles.listIcon}>
              <RemoveRedEye/>
            </ListItemIcon>
            <ListItemText className={styles.listText}>
              {setViewLabel}
            </ListItemText>
          </MenuItem>
        </Fragment>      
      }
      { !disableSetOwner &&
        <MenuItem data-test="privilegeOwnerOption" onClick={this.handleChange(OWNER)}>
          <ListItemIcon className={styles.listIcon}>
            <VpnKey/>
          </ListItemIcon>
          <ListItemText className={styles.listText}>
            {setOwnerLabel}
          </ListItemText>
        </MenuItem>
      }
      </Popover>
    )
  }

  drawRoleItems() {
    const { permission, ownerLabel, managerLabel, inheritLabel, toolTipText, disableSetOwner } = this.props;

    switch (permission) {
      case EDITOR:
      case VIEWER:
      return (
        <Fragment>
          <Tooltip title={toolTipText}>
            <span data-test="accessChangeBtn" className={styles.actionIcon} onClick={this.handleEditClick(EDITOR)}>
              {permission == EDITOR? <Edit data-test="accessChangeEditor"/> : <RemoveRedEye data-test="accessChangeViewer"/>}
              <ArrowDropDown data-test="accessChangeArrowIcon" className={styles.arrowIcon}/>
            </span>
          </Tooltip>
          <Tooltip title='Delete'>
            <span data-test="userPreivilegeDeleteBtn" className={styles.actionIcon} onClick={this.handleDelete}>
            <Delete/>
            </span>
          </Tooltip>
        </Fragment>
      );
      case OWNER: 
      return (
        <Fragment>
          <span className={styles.icon}><VpnKey/></span>
          <span data-test="userPreivilegeOwnerLabel">{ownerLabel}</span>
        </Fragment>
      );
      case MANAGER: 
      return (
        <Fragment>
          <span className={styles.icon}><AssignmentInd/></span>
          <span data-test="userPreivilegeManagerLabel">{managerLabel}</span>
          {
            !disableSetOwner &&
            <Tooltip title={toolTipText}>
              <span data-test="accessChangeManager" className={styles.actionIcon} onClick={this.handleEditClick(MANAGER)}>
                <Edit/>
                <ArrowDropDown className={styles.arrowIcon}/>
              </span>
            </Tooltip>
          }
        </Fragment>
      );
      case INHERIT: 
      return <span>{inheritLabel}</span>;
    }
  }

  render() {
    const { firstName, lastName, email, profileImage, isCurrentUser } = this.props;
    const badge = isCurrentUser && [<span className={styles.userBadge} key={firstName + lastName}>(You)</span>];
    return (
      <div className={styles.userPrivilegeInfo}>
        <CompactUserInfo
          firstName={firstName}
          lastName={lastName}
          subtitle={email}
          profileImage={profileImage}
          badges={badge}
        />
        <div className={styles.roleItemsContainer}>
          {this.drawRoleItems()}
        </div>
        {this.drawPopover()}
      </div>
    )
  }
}
